var _title, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEdit = function SvgIconEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "20px",
    viewBox: "0 0 15 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "6868B3CB-BC5D-4528-B837-A33417D5CF22@1.5x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.28785 0 1.4877 0 1.4877 1.2 0.28785 1.2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phase-1---In-App-Flows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KDDI-Profile-001",
    transform: "translate(-369.000000, -406.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Povo-Edit-Icon",
    transform: "translate(369.000000, 406.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.52849,17.55 L4.74609,17.55 C4.37649,17.55 4.08729,17.8137 4.08729,18.15 C4.08729,18.4863 4.37649,18.75 4.74609,18.75 L11.52849,18.75 C11.89779,18.75 12.18729,18.4863 12.18729,18.15 C12.18729,17.8137 11.89779,17.55 11.52849,17.55",
    id: "Fill-1",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71001,5.31975 C9.59061,5.25015 9.44181,5.23185 9.30351,5.26965 C9.16281,5.30805 9.04761,5.39655 8.97861,5.51925 L3.95361,14.36235 C3.46911,15.19605 2.80191,15.91545 2.02491,16.44225 L1.12581,17.04165 L1.18761,15.95265 C1.23651,15.00525 1.51611,14.05965 1.99521,13.21815 L7.02111,4.37475 C7.16511,4.11765 7.07511,3.77775 6.82461,3.63225 C6.73371,3.57915 6.62781,3.55545 6.52041,3.56415 C6.33891,3.57825 6.17871,3.67815 6.09291,3.83175 L1.08441,12.67455 C0.53061,13.63635 0.20241,14.74515 0.13431,15.88065 L0.00201,18.05685 C-0.01599,18.25545 0.08871,18.45465 0.26811,18.56415 C0.34881,18.61365 0.43671,18.63765 0.53661,18.63765 C0.63621,18.63765 0.74301,18.60555 0.83931,18.54675 L2.63061,17.34855 C3.56841,16.70655 4.34661,15.86205 4.88121,14.90565 L9.90681,6.06225 C10.05111,5.80575 9.96081,5.46555 9.71001,5.31975",
    id: "Fill-3",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90102,0.00147 C9.68562,-0.00633 9.46722,0.01797 9.25092,0.07677 C8.67492,0.23337 8.20032,0.61707 7.91202,1.13967 L7.30212,2.27277 C7.16652,2.51667 7.25112,2.84817 7.48842,2.98767 L10.42032,4.73067 C10.50522,4.78287 10.59012,4.79997 10.67472,4.79997 C10.72542,4.79997 10.75902,4.79997 10.81002,4.78257 C10.94562,4.74777 11.04732,4.66047 11.11542,4.53867 L11.74242,3.40557 C12.03042,2.88267 12.11532,2.27307 11.96262,1.68027 C11.80992,1.08777 11.43732,0.59967 10.92912,0.30327 C10.61112,0.11817 10.26012,0.01467 9.90102,0.00147",
    id: "Fill-5",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(12.900000, 17.550000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.88785,1.2 C1.21905,1.2 1.48785,0.9312 1.48785,0.6 C1.48785,0.2688 1.21905,0 0.88785,0 C0.55665,0 0.28785,0.2688 0.28785,0.6 C0.28785,0.9312 0.55665,1.2 0.88785,1.2",
    id: "Fill-7",
    fill: "#333333",
    mask: "url(#mask-2)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-edit.3c561e53.svg";
export { ForwardRef as ReactComponent };